module.exports = __webpack_public_path__ + "img/34.93ef5456.png";